import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class Settings {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <div class="fg-settings">
                <section class="fg-settings-section">
                    <div class="fg-settings-section__head">Notifications</div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Push Notifications</div>
                            <div class="fg-setting-row__desc">Receive notifications for breaking news and updates</div>
                        </div>
                        <div class="fg-toggle is-on" role="switch" aria-checked="true" tabindex="0" data-toggle></div>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Email Notifications</div>
                            <div class="fg-setting-row__desc">Get email updates about your favorite teams and players</div>
                        </div>
                        <div class="fg-toggle is-on" role="switch" aria-checked="true" tabindex="0" data-toggle></div>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Match Alerts</div>
                            <div class="fg-setting-row__desc">Get notified before matches start</div>
                        </div>
                        <div class="fg-toggle" role="switch" aria-checked="false" tabindex="0" data-toggle></div>
                    </div>
                </section>

                <section class="fg-settings-section">
                    <div class="fg-settings-section__head">Privacy</div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Profile Visibility</div>
                            <div class="fg-setting-row__desc">Control who can see your profile information</div>
                        </div>
                        <select class="fg-select-inline" aria-label="Profile visibility">
                            <option value="public">Public</option>
                            <option value="friends">Friends Only</option>
                            <option value="private">Private</option>
                        </select>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Activity Status</div>
                            <div class="fg-setting-row__desc">Show when you're active on the platform</div>
                        </div>
                        <div class="fg-toggle is-on" role="switch" aria-checked="true" tabindex="0" data-toggle></div>
                    </div>
                </section>

                <section class="fg-settings-section">
                    <div class="fg-settings-section__head">Content Preferences</div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Language</div>
                            <div class="fg-setting-row__desc">Choose your preferred language</div>
                        </div>
                        <select class="fg-select-inline" aria-label="Language">
                            <option value="en">English</option>
                            <option value="es">Español</option>
                            <option value="fr">Français</option>
                            <option value="de">Deutsch</option>
                        </select>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Content Filter</div>
                            <div class="fg-setting-row__desc">Filter content based on your preferences</div>
                        </div>
                        <select class="fg-select-inline" aria-label="Content filter">
                            <option value="all">All Content</option>
                            <option value="family">Family Friendly</option>
                            <option value="strict">Strict</option>
                        </select>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Auto-play Videos</div>
                            <div class="fg-setting-row__desc">Automatically play videos when scrolling</div>
                        </div>
                        <div class="fg-toggle" role="switch" aria-checked="false" tabindex="0" data-toggle></div>
                    </div>
                </section>

                <section class="fg-settings-section">
                    <div class="fg-settings-section__head">Account</div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Change Password</div>
                            <div class="fg-setting-row__desc">Update your account password</div>
                        </div>
                        <button type="button" class="fg-btn fg-settings-action" data-action="password">Change</button>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Two-Factor Authentication</div>
                            <div class="fg-setting-row__desc">Add an extra layer of security to your account</div>
                        </div>
                        <div class="fg-toggle" role="switch" aria-checked="false" tabindex="0" data-toggle></div>
                    </div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Download Data</div>
                            <div class="fg-setting-row__desc">Download a copy of your data</div>
                        </div>
                        <button type="button" class="fg-btn fg-settings-action" data-action="download">Download</button>
                    </div>
                </section>

                <section class="fg-settings-section fg-settings-section--danger">
                    <div class="fg-settings-section__head">Danger Zone</div>
                    <div class="fg-setting-row">
                        <div>
                            <div class="fg-setting-row__title">Delete Account</div>
                            <div class="fg-setting-row__desc">Permanently delete your account and all data</div>
                        </div>
                        <button type="button" class="fg-btn fg-btn--danger fg-settings-action" data-action="delete">Delete</button>
                    </div>
                </section>
            </div>
        `;

        el.innerHTML = sidebarPage({
            title: 'Settings',
            subtitle: 'Customize your FootballGirl experience',
            main,
            wide: true
        });

        el.querySelectorAll('[data-toggle]').forEach((t) => {
            const flip = () => {
                t.classList.toggle('is-on');
                const on = t.classList.contains('is-on');
                t.setAttribute('aria-checked', on ? 'true' : 'false');
            };
            t.addEventListener('click', flip);
            t.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    flip();
                }
            });
        });

        el.querySelectorAll('.fg-settings-action').forEach((btn) => {
            btn.addEventListener('click', () => {
                const action = btn.getAttribute('data-action');
                const messages = {
                    password: 'Change password flow coming soon.',
                    download: 'Data export coming soon.',
                    delete: 'Account deletion must be confirmed in a future release.'
                };
                window.alert(messages[action] || 'Coming soon.');
            });
        });
    }
}
